import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Divider, Form, Col, Row,
} from 'antd';
import { getAtmedVendorPharmacyInfo, updateAtmedVendorPharmacy } from '../../../../store/actions';
import styles from '../../../profile/profile.module.scss';
import AvatarUploader from '../../../../common/AvatarUploader';
import { ATMED_VENDOR_PHARMACY_DOCUMENTS } from '../../../../common/awsBucket';

function Profile(props) {
  const [profile, setProfile] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    const { id } = props;
    form.resetFields();
    props.getAtmedVendorPharmacyInfo(`${id}`);
    return () => {
      form.resetFields();
      setProfile(null);
    };
  }, []);
  useEffect(() => {
    setProfile(props.profileInfo);
    form.setFieldsValue(props.profileInfo);
  }, [props.profileInfo]);

  const docUploadSuccess = (uploadUrl, key) => {
    const item = {};
    item[key] = uploadUrl;
    const payload = {
      pharmacy_vendor: item,
    };
    const payloadObj = {
      id: props.id,
      payload,
    };
    props.updateAtmedVendorPharmacy(payloadObj);
    props.getAtmedVendorPharmacyInfo(`${props.id}`);
  };
  const getValueFromEvent = (e) => {
    const { file, target } = e;
    const { response } = file || {};
    const { value } = target || {};
    return response || value;
  };
  const config = [
    {
      key: 'pic_url',
      label: 'Logo',
      getValueFromEvent,
      editComponent: <AvatarUploader uploadBucketName={ATMED_VENDOR_PHARMACY_DOCUMENTS} uploadSuccess={(e) => docUploadSuccess(e, 'pic_url')} />,
    },
    {
      key: 'business_registration_url',
      label: 'Business Registration',
      getValueFromEvent,
      editComponent: <AvatarUploader uploadBucketName={ATMED_VENDOR_PHARMACY_DOCUMENTS} uploadSuccess={(e) => docUploadSuccess(e, 'business_registration_url')} />,
    },
    {
      key: 'business_pan_url',
      label: 'Business PAN',
      getValueFromEvent,
      editComponent: <AvatarUploader uploadBucketName={ATMED_VENDOR_PHARMACY_DOCUMENTS} uploadSuccess={(e) => docUploadSuccess(e, 'business_pan_url')} />,
    },
    {
      key: 'bank_account_url',
      label: 'Bank Account',
      getValueFromEvent,
      editComponent: <AvatarUploader uploadBucketName={ATMED_VENDOR_PHARMACY_DOCUMENTS} uploadSuccess={(e) => docUploadSuccess(e, 'bank_account_url')} />,
    },
    {
      key: 'auth_proof_url',
      label: 'Authorized Proof',
      getValueFromEvent,
      editComponent: <AvatarUploader uploadBucketName={ATMED_VENDOR_PHARMACY_DOCUMENTS} uploadSuccess={(e) => docUploadSuccess(e, 'auth_proof_url')} />,
    },
    {
      key: 'auth_pan_url',
      label: 'Authorized PAN',
      getValueFromEvent,
      editComponent: <AvatarUploader uploadBucketName={ATMED_VENDOR_PHARMACY_DOCUMENTS} uploadSuccess={(e) => docUploadSuccess(e, 'auth_pan_url')} />,
    },
    {
      key: 'board_resolution_url',
      label: 'Board Resolution',
      getValueFromEvent,
      editComponent: <AvatarUploader uploadBucketName={ATMED_VENDOR_PHARMACY_DOCUMENTS} uploadSuccess={(e) => docUploadSuccess(e, 'board_resolution_url')} />,
    },
    {
      key: 'moa_url',
      label: 'MOA',
      getValueFromEvent,
      editComponent: <AvatarUploader uploadBucketName={ATMED_VENDOR_PHARMACY_DOCUMENTS} uploadSuccess={(e) => docUploadSuccess(e, 'moa_url')} />,
    },
    {
      key: 'aoa_url',
      label: 'AOA',
      getValueFromEvent,
      editComponent: <AvatarUploader uploadBucketName={ATMED_VENDOR_PHARMACY_DOCUMENTS} uploadSuccess={(e) => docUploadSuccess(e, 'aoa_url')} />,
    },
    {
      key: 'service_agreement_url',
      label: 'Service Agreement',
      getValueFromEvent,
      editComponent: <AvatarUploader uploadBucketName={ATMED_VENDOR_PHARMACY_DOCUMENTS} uploadSuccess={(e) => docUploadSuccess(e, 'service_agreement_url')} />,
    },
    {
      key: 'iso_url',
      label: 'ISO',
      getValueFromEvent,
      editComponent: <AvatarUploader uploadBucketName={ATMED_VENDOR_PHARMACY_DOCUMENTS} uploadSuccess={(e) => docUploadSuccess(e, 'iso_url')} />,
    },
    {
      key: 'license_url',
      label: 'License',
      getValueFromEvent,
      editComponent: <AvatarUploader uploadBucketName={ATMED_VENDOR_PHARMACY_DOCUMENTS} uploadSuccess={(e) => docUploadSuccess(e, 'license_url')} />,
    }

  ];

  return profile ? (
    <div className={styles.mainContainer}>
      <Form
        form={form}
        initialValues={profile}
        layout="vertical"
        name="editProfile"
      >
        <Row gutter={24}>
          {config.map((rowConfig) => (
            <Col
              xs={24}
              md={rowConfig.width ? rowConfig.width : 12}
              lg={rowConfig.width ? rowConfig.width : 12}
              key={rowConfig.key}
            >
              <p>
                <b>{rowConfig.label}</b>
              </p>
              <Form.Item name={rowConfig.key} style={{ paddingLeft: '30px' }}>
                {rowConfig.editComponent}
              </Form.Item>
              <Divider />
            </Col>

          ))}
        </Row>

      </Form>
    </div>
  ) : null;
}

const mapStateToProps = ({ vendorEquipmentReducer = {} }) => ({
  profileInfo: vendorEquipmentReducer.singleVendorEquipment,

});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getAtmedVendorPharmacyInfo,
    updateAtmedVendorPharmacy,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
